<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <section>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-page-title-layout">
              <div>
                <h1 class="boss-page-title boss-page-title-layout-title">
                  応募者へメッセージを一括送信
                </h1>
              </div>
            </div>
          </div>
          <Accordion
            :is-open="isOpen"
            class="pega-visible"
          >
            <template #head>
              {{ `送信対象者一覧（全${entryIds.length}名）` }}
            </template>
            <template #body>
              <div>
                <div class="boss-table-wrap">
                  <table class="boss-table-4">
                    <tr>
                      <th>応募日</th>
                      <th>応募者</th>
                      <th class="is-boss-only-pc">
                        求人
                      </th>
                      <th>アプローチ状況</th>
                      <th>メッセージ</th>
                      <th class="is-boss-only-pc">
                        選考
                        <br>フェーズ
                      </th>
                      <th class="is-boss-only-pc">
                        選考
                        <br>ステータス
                      </th>
                      <th class="is-boss-only-pc">
                        備考
                      </th>
                    </tr>
                    <entry-bulk-message-target
                      v-for="(entry, i) in entries"
                      :key="i"
                      :entry="entry"
                    />
                  </table>
                </div>
              </div>
            </template>
          </Accordion>
          <!-- メッセージ作成コンポーネント -->
          <entry-message-register
            :entry-ids="entryIds"
          />
          <!-- メッセージ作成コンポーネント -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import EntryBulkMessageTarget from '@/components/molecules/EntryBulkMessageTarget'
import EntryMessageRegister from '@/components/organisms/EntryMessageRegister'
import Accordion from '@/components/atoms/Accordion'

export default {
  components: {
    Accordion,
    EntryBulkMessageTarget,
    EntryMessageRegister
  },
  props: {
    entryIds: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      entries: [],
      isOpen: true
    }
  },
  created () {
    this.$http.secured.post('/entry/view/entries', this.entryIds)
      .then(response => {
        this.entries = response.data
      })
  }
}
</script>
